import { size } from 'lodash-es';
import { BACKGROUND_COLOR_LIST } from "../utils/theme";

export class ColorGeneratorService {
	private readonly  colorsList = BACKGROUND_COLOR_LIST;
	private currentIndex: number;

	constructor() {
		this.currentIndex = 0;
	}

	get color() {
		return this.colorsList[this.currentIndex];
	}

	public getNextColor(exceptColor?: string): string {
		const color = this.colorsList[this.currentIndex];
		this.currentIndex = (this.currentIndex + 1) % size(this.colorsList);

		if (color === exceptColor) {
			return this.getNextColor();
		}

		return color;
	}
}
